module.exports = __webpack_public_path__ + "static/media/16UNODC14.2be55be2.jpg";